import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-secondary text-secondary-foreground overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center space-x-3 mb-6 md:mb-8">
              <img 
                src="/assets/images/ChatGPT_Image_Feb_3_2026_04_58_59_PM-1770675660365.png" 
                alt="Draggin Trailers Logo" 
                className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain rounded-lg shadow-elevation-3"
              />
              <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl">Draggin Trailers</h1>
            </div>

            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-4 md:mb-6 leading-tight">
              Rent trailers from locals or list yours to earn.
            </h2>
            
            <p className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-primary mb-6 md:mb-8">
              Simple. Bold. Unstoppable.
            </p>

            <p className="font-body text-base md:text-lg lg:text-xl text-secondary-foreground/80 mb-8 md:mb-10 max-w-2xl mx-auto lg:mx-0">
              Connect with local trailer owners for your hauling needs or turn your idle trailer into a revenue stream. Join the peer-to-peer trailer rental revolution.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => navigate('/search-results')}
                className="px-6 py-3 md:px-8 md:py-4 bg-primary text-primary-foreground font-body font-medium text-base md:text-lg rounded-md transition-smooth hover:opacity-90 shadow-elevation-2">
                Browse Trailers
              </button>
              <button
                onClick={() => navigate('/trailer-listing-creation')}
                className="px-6 py-3 md:px-8 md:py-4 bg-accent text-accent-foreground font-body font-medium text-base md:text-lg rounded-md transition-smooth hover:opacity-90 shadow-elevation-2">
                List Your Trailer
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary/20 rounded-2xl blur-xl"></div>
              <div className="relative bg-card rounded-xl shadow-elevation-4 p-6 md:p-8">
                <div className="grid grid-cols-2 gap-4 md:gap-6">
                  <div className="text-center">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                      <Icon name="MapPin" size={24} color="var(--color-primary)" strokeWidth={2} className="md:w-8 md:h-8" />
                    </div>
                    <p className="font-heading font-bold text-2xl md:text-3xl text-foreground mb-1">50</p>
                    <p className="font-caption text-xs md:text-sm text-muted-foreground">States Covered</p>
                  </div>

                  <div className="text-center">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                      <Icon name="Star" size={24} color="var(--color-primary)" strokeWidth={2} className="md:w-8 md:h-8" />
                    </div>
                    <p className="font-heading font-bold text-2xl md:text-3xl text-foreground mb-1">4.8</p>
                    <p className="font-caption text-xs md:text-sm text-muted-foreground">Average Rating</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;